<template>
    <div class="container mb-8">
        <ais-instant-search
            :search-client="searchClient"
            :index-name="selectedIndex"
            :routing="routing"
        >
            <ais-configure
                :hits-per-page.camel="24"
                :ignore-plurals.camel="true"
            />

            <ais-current-refinements
                v-slot="{ items }"
                :included-attributes="['roam_products_categories.lvl0']"
            >
                {{ setEventsActive(items) }}
            </ais-current-refinements>

            <div class="p-search__query">
                <ais-search-box placeholder="Search for…" />
                <span>in</span>
                <ais-menu-select
                    v-slot="{ items, canRefine, refine }"
                    attribute="roam_products_regions.lvl0"
                >
                    <Select
                        :items="items"
                        :canRefine="canRefine"
                        :refine="refine"
                        placeholder="Everywhere"
                    />
                </ais-menu-select>
            </div>

            <div class="p-search__filters">
                <Categories />
                <RoamDateSelect v-if="isEventsActive" attribute="roam_products_eventDates" />
            </div>

            <div class="mb-12 sm:mb-32">
                <ais-hits>
                    <template slot="item" slot-scope="{ item }">
                        <Deal :item="item" />
                    </template>
                </ais-hits>

                <ais-pagination :show-first="false" :show-last="false" @page-change="scrollTop" />
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import routing from './routing';
import Deal from './components/Deal.vue';
import Categories from './components/Categories.vue';
import RoamDateSelect from './components/DateSelect.vue';
import Select from './components/Select.vue';

export default {
    name: 'DealsSearch',

    components: {
        Deal,
        Categories,
        RoamDateSelect,
        Select,
    },

    data() {
        const index = `deals_${this.$root.hub}`;

        return {
            searchClient: algoliasearch(window.algolia.id, window.algolia.key),
            selectedIndex: index,
            routing: routing(index),
            currentTimestamp: Math.floor(Date.now() / 1000),
        };
    },

    methods: {
        setEventsActive(refinements) {
            this.isEventsActive = refinements.some(
                (refinement) => refinement.attribute === 'roam_products_categories.lvl0'
                && refinement.refinements.some((cat) => cat.value === "What's On"),
            );
        },

        scrollTop() {
            const el = this.$refs.search;
            el.scrollIntoView();
        },
    },
};
</script>

<style scoped>
.subitem-wrapper {
    &::before,
    &::after {
        margin: auto;
        content: '';
    }
}
</style>
